"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const b_1 = __importDefault(require("b_"));
const input_1 = __importDefault(require("src/components/input"));
const question_1 = __importDefault(require("../question"));
const question_geo_text_styles_1 = __importDefault(require("./question-geo-text.styles"));
const b = b_1.default.with('geo');
const DEFAULT_PROPS = {
    handleChange: () => { },
    handleFocus: () => { },
    handleBlur: () => { },
    handleSelect: () => { },
    id: '',
    accuracy: 'locality',
    lang: 'ru',
    value: '',
    type: '',
    children: []
};
class Geo extends react_2.Component {
    constructor(props) {
        super(props);
        this.getSuggestions = (part = '', accuracy = 'locality', lang = 'ru') => __awaiter(this, void 0, void 0, function* () {
            const url = `https://suggest-maps.yandex.ru/suggest-geo?client_id=surveys&fullpath=0&results=5&type=tp&short_names=0&bases=${accuracy}&part=${part}&v=9&outformat=json&cut_country_from_fullpath=1&lang=${lang}&keep_spec_ops_regions=0`;
            try {
                const json = yield fetch(url);
                const response = yield json.json();
                return response;
            }
            catch (e) {
                throw new Error(e);
            }
        });
        // https://wiki.yandex-team.ru/suggest/geo/
        this.parseSuggestions = (data = { results: [], part: '' }) => {
            const items = data.results.map(item => {
                return { displayName: item.text, value: item.text };
            });
            return { items, part: data.part };
        };
        this.handleChange = (e) => __awaiter(this, void 0, void 0, function* () {
            const { getSuggestions, parseSuggestions } = this;
            const { lang, accuracy, handleChange } = this.props;
            this.setState({ value: e.target.value });
            handleChange(e);
            // TODO добавить debounce и проверять что компонент не размаунтился на момент получения ответа
            return getSuggestions(e.target.value, accuracy, lang)
                .then(data => parseSuggestions(data))
                .then(({ items, part }) => {
                // Если запросы будут идти долго, то саджест может отстать от ввода
                // Этим условием проверяем, что данные в саджесте соответствуют текущему тексту в инпуте
                if (part === this.state.value) {
                    this.setState({ suggestItems: items });
                }
            });
        });
        this.handleFocus = e => {
            this.props.handleFocus(e);
        };
        this.handleBlur = e => {
            this.props.handleBlur(e);
        };
        this.handlerSelect = e => {
            const { handleSelect, id } = this.props;
            this.setState({
                value: e.target.dataset.title,
                suggestItems: []
            });
            handleSelect({ index: id, value: e.target.dataset.value });
        };
        this.handlerClose = () => {
            this.setState({ suggestItems: [] });
        };
        this.refControlCb = component => {
            if (component) {
                this.control = component.control;
            }
        };
        this.state = {
            suggestItems: [],
            value: props.value // Можем получить данные из LS
        };
    }
    renderSuggest() {
        const { handlerSelect, handlerClose } = this;
        const { suggestItems } = this.state;
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('suggest-container') }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('suggest') }, { children: suggestItems.map(({ displayName, value }) => {
                        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('item'), "data-value": value, "data-title": displayName, onClick: handlerSelect }, { children: displayName }), displayName));
                    }) })), (0, jsx_runtime_1.jsx)("div", { className: b('suggest-cover'), onClick: handlerClose })] })));
    }
    render() {
        const _a = this.props, { id, children, type } = _a, rest = __rest(_a, ["id", "children", "type"]);
        const { suggestItems, value } = this.state;
        const { handleChange, handleBlur, handleFocus } = this;
        return ((0, jsx_runtime_1.jsxs)(question_1.default, Object.assign({}, rest, { id: id }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: question_geo_text_styles_1.default }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: type }, { children: [(0, jsx_runtime_1.jsx)(input_1.default, { "data-index": id, size: 'dependent', value: value, onChange: e => {
                                void handleChange(e);
                            }, onBlur: e => {
                                void handleBlur(e);
                            }, onFocus: e => {
                                void handleFocus(e);
                            }, ref: this.refControlCb }), (suggestItems.length && this.renderSuggest()) || null] })), children] })));
    }
}
exports.default = Geo;
Geo.defaultProps = DEFAULT_PROPS;
